import React, { Component } from 'react';
import LayoutHeader from '../Inc/Header';
import * as actions from '../../actions/index';
import AlumniNavigation from '../Inc/AlumniNavigation';
import SearchAlumni from '../Inc/SearchAlumni';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class AdvancedSearch extends Component {

  constructor(props) {
    super(props)
    this.state = {
      ...props,
    }
  }

  componentDidMount = () =>{
    if(localStorage.getItem('prevpath') == 'alumnisearch'){
      localStorage.setItem('prevpath', 'adminsearch')
      window.location.reload()
    }else {
      localStorage.setItem('prevpath', 'adminsearch')
    }

    if (window.performance) {
      if (performance.navigation.type == 1) {
        localStorage.removeItem('QuickSearchExp')
        localStorage.removeItem('ContextToken')
        //window.location.reload()
      }
    }
  }

  render() {
    return (
      <div>
        <LayoutHeader />
        <AlumniNavigation />
        <div className='quick-search-widget'>
          <SearchAlumni />
        </div>
      </div>
    );
  }

}

function mapStateToProps(state) {
  return {
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(AdvancedSearch);



// WEBPACK FOOTER //
// ./src/components/QuickSearch/AdvancedSearch.js